import {alpha, Box, styled, Theme, Typography} from '@mui/material';

export const ProductCardLEOContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  borderRadius: theme.spacing(0.5),
  overflow: 'hidden',
  '&.PDPRevamp': {
    border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(1)
  },
  '&.PDPRevamp.compact': {
    border: 'none',
    borderRadius: 0
  }
}));

export const StyledProductContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  minWidth: theme.spacing(20),
  minHeight: theme.spacing(36.25),
  gap: theme.spacing(0.5),
  backgroundColor: theme.palette.common.mds_global_color_white,
  position: 'relative',
  paddingLeft: theme.spacing(0),
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: theme.spacing(1),
  '&.onlyImage': {
    padding: 0,
    border: 'none',
    height: '100%'
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: theme.spacing(12),
    minHeight: theme.spacing(20.5)
  }
})) as typeof Box;

export const StyledProductWrapper = styled(Box)(({theme}) => ({
  flexGrow: 1,
  display: 'block',
  cursor: 'pointer',
  textDecoration: 'none',
  marginBottom: theme.spacing(0.5),
  '&.onlyImage': {
    marginBottom: 0
  }
})) as typeof Box;

export const StyledImageCardContainer = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  overflow: 'hidden',
  borderRadius: theme.spacing(1),
  position: 'relative',
  '&.onlyImage': {
    height: '100%'
  }
})) as typeof Box;

export const StyledFooterContainer = styled(Box)(({theme}) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
  height: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(0)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`
  }
})) as typeof Box;

export const DisplayTitleWrapper = styled(Box)(({theme}: {theme: Theme}) => ({
  whiteSpace: 'normal',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: theme.palette.common.black,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordBreak: 'break-word'
})) as typeof Box;

export const DisplayText = styled('span')(({theme}) => ({
  fontSize: theme.spacing(1.75),
  lineHeight: theme.spacing(2.5),
  fontWeight: 700,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2.25),
    fontWeight: 600
  }
}));

export const ProductStatusContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  flexDirection: 'column',
  alignItems: 'center',
  height: theme.spacing(25),
  minHeight: theme.spacing(25),
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(20),
    minHeight: theme.spacing(20)
  }
})) as typeof Box;

export const ProductStatusComponent = styled(Box)(({theme}) => ({
  position: 'absolute',
  zIndex: 1,
  borderRadius: theme.spacing(3),
  background: '#000000B2',
  height: 'auto',
  top: '-50%'
})) as typeof Box;

export const ProductStatusLabel = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(1.75),
  lineHeight: theme.spacing(2.5),
  fontWeight: 700,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  alignItems: 'center',
  color: theme.palette.common.white,
  textAlign: 'center'
})) as typeof Typography;

export const StyledDiscountContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(0.25),
  gap: theme.spacing(1.5),
  borderRadius: theme.spacing(0.5),
  width: 'fit-content',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0.4375, 0.5, 0.4875, 1),
  position: 'relative'
})) as typeof Box;

export const StyledDiscountStrikeText = styled(Typography)(({theme}) => ({
  color: (theme.palette.common as any).mds_global_color_white,
  fontWeight: 400,
  textDecorationLine: 'line-through',
  display: 'flex',
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(1.8),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.5)
  }
})) as typeof Typography;

export const StyledDiscountPercentageValue = styled(Typography)(({theme}) => ({
  color: (theme.palette.common as any).mds_global_color_white,
  fontStyle: 'normal',
  fontWeight: 600,
  height: 14,
  lineHeight: theme.spacing(1.75),
  position: 'absolute',
  fontSize: theme.spacing(1.75),
  paddingLeft: theme.spacing(0.5),
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
})) as typeof Typography;

export const StyledSlabPriceText = styled(Typography)(({theme}) => ({
  color: (theme.palette.common as any).mds_global_color_red_25,
  fontWeight: 600,
  display: 'flex',
  fontSize: theme.spacing(1.75),
  lineHeight: theme.spacing(1.5),
  marginTop: theme.spacing(0.25),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(0.5)
  }
})) as typeof Typography;

export const CountdownTimerContainer = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: theme.spacing(1.25),
  left: '50%',
  transform: 'translateX(-50%)'
})) as typeof Box;

export const StyledAddToCartWrapper = styled(Box)(({theme}) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(0)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`
  }
})) as typeof Box;

export const StyledProductDeliveryWrapper = styled(Box)(({theme}) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(0)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`
  }
})) as typeof Box;

export const ProductImageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showFrame' && prop !== 'aspectRatio' && prop !== 'scaleFactor'
})<{
  showFrame: boolean;
  aspectRatio?: string;
  scaleFactor?: number;
}>(({showFrame, aspectRatio, scaleFactor}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  aspectRatio: aspectRatio,
  margin: '0 auto',
  transform: showFrame ? `scale(${scaleFactor})` : 'scale(1)',
  transformOrigin: 'center'
}));

export const StyledFloatingQuantityPickerContainer = styled(Box)(({theme}) => ({
  position: 'absolute',
  zIndex: 3,
  top: '89%',
  left: '50%',
  width: '93%',
  transform: 'translate(-50%, -50%)',
  '&.normal_search': {
    top: '85%',
    left: '46%',
    width: '85%'
  },
  '&.isProductCardV2': {
    top: '50%',
    left: '47%',
    width: '88%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      top: '50%',
      left: '46%',
      width: '88%',
      transform: 'translate(-50%, -50%)'
    }
  }
})) as typeof Box;

export const StyledPromoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(0)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)}`
  }
})) as typeof Box;

export const StyledBrandPromoWrapper = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 0,
  marginLeft: theme.spacing(1),
  marginTop: theme.spacing(1)
})) as typeof Box;

export const StyledBrandPromoImage = styled('img')(({theme}) => ({
  maxWidth: '100%',
  maxHeight: '100%',
  display: 'inline-block',
  verticalAlign: 'middle',
  width: theme.spacing(5.75),
  objectFit: 'contain'
}));

export const CompactCardAddToCartBtnHolder = styled(Box)(({theme}) => ({
  position: 'absolute',
  right: theme.spacing(0.5),
  bottom: theme.spacing(0.5),
  zIndex: 2
})) as typeof Box;

export const StyledOutofContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
})) as typeof Box;

export const StyledImageContainer = styled(Box)(() => ({
  position: 'absolute'
})) as typeof Box;

export const StyledOutofText = styled(Box)(({theme}: {theme: Theme}) => ({
  padding: theme.spacing(0, 2),
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  borderRadius: 32,
  height: 42,
  lineHeight: '42px',
  position: 'relative',
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.common.white,
  [theme.breakpoints.down('sm')]: {
    height: 34,
    lineHeight: '34px',
    fontSize: 14
  }
})) as typeof Box;

export const ImageWrapper = styled(Box)(() => ({
  flexGrow: 1,
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
  height: '100%',
  objectFit: 'contain',
  '&.marketingBadgeV2': {
    width: '70%',
    maxWidth: '70%',
    height: '70%'
  }
})) as typeof Box;

export const RootWrapper = styled(Box)(() => ({
  display: 'flex',
  flexGrow: 1,
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'transparent',
  boxSizing: 'border-box',
  height: '100%'
})) as typeof Box;

export const AddToCartBtnHolder = styled(Box)(({theme}) => ({
  position: 'absolute',
  right: theme.spacing(0.5),
  bottom: theme.spacing(0.5),
  padding: theme.spacing(1),
  zIndex: 1,
  '&.normal': {
    left: 0
  }
})) as typeof Box;
